import { render, staticRenderFns } from "./OTPView.vue?vue&type=template&id=3e1401b0&scoped=true"
import script from "./OTPView.vue?vue&type=script&lang=js"
export * from "./OTPView.vue?vue&type=script&lang=js"
import style0 from "./OTPView.vue?vue&type=style&index=0&id=3e1401b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1401b0",
  null
  
)

export default component.exports